import React from "react";
import ReactDOM from "react-dom";
import Recaptcha from 'react-recaptcha';

export default class ContactAdvertiserModal extends React.Component {
    state = {
        _userimge: null,
        error: null,
        ads_contact_email: null,
        ads_contact_number: null,
        ads_whatsapp_number: null,
        apply_method: null,
        name_of_announcer: null,
        __url: null,
        ads_id: null,
        _ads_title: null,
        Recaptcha: false
    }

    constructor(props) {
        super(props);
        this.fetchAdvertDetails(props.advert_id, props._userimge, props.ads_title);
        this.escFunction = this.escFunction.bind(this);

        __gaTracker('send', 'event', {
            eventCategory: 'Show Contact Details',
            eventAction: 'first',
            eventLabel: window.location.href
        });
    }

    escFunction(event) {
        if (event.keyCode === 27) {
            this.onToggle();
        }
    }
    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }
    fetchAdvertDetails(advert_id, _userimge, ads_title, recaptchaResponse = null) {
        let _url = `${BASE.url}adverts/get-ad-advertiser-details?advert_id=${advert_id}`;

        if (this.state.Recaptcha && recaptchaResponse) {
            _url = (`${_url}&g-recaptcha-response=${recaptchaResponse}`)
        }

        fetch(_url)
            .then(res => res.json())
            .then(res => {
                if (res.status.code == 400) {
                    this.setState({
                        Recaptcha: true
                    });

                    __gaTracker('send', 'event', {
                        eventCategory: 'Show Contact Details',
                        eventAction: 'request recaptcha',
                        eventLabel: window.location.href
                    });

                    return;
                }

                this.setState({
                    Recaptcha: false
                });

                const state = {}
                const { data } = res;
                const { ads_contact_email, ads_contact_number, ads_whatsapp_number, apply_method, name_of_announcer } = data;
                if ('ads_contact_email' in data) { state['ads_contact_email'] = ads_contact_email }
                if ('ads_contact_number' in data) { state['ads_contact_number'] = ads_contact_number }
                if ('ads_whatsapp_number' in data) { state['ads_whatsapp_number'] = ads_whatsapp_number }
                if ('name_of_announcer' in data) { state['name_of_announcer'] = name_of_announcer }
                if ('apply_method' in data) { state['apply_method'] = apply_method }

                this.setState({
                    ads_contact_email,
                    ads_contact_number,
                    ads_whatsapp_number,
                    apply_method,
                    name_of_announcer,
                    __url: _url,
                    ads_id: advert_id,
                    _userimge : _userimge,
                    _ads_title: ads_title
                });
                __gaTracker('send', 'event', {
                    eventCategory: 'Show Contact Details',
                    eventAction: 'show',
                    eventLabel: window.location.href
                });
            });
    }

    onToggle = () => {
        let createAdvertModalElement = document.querySelector('#createAdvertModal');
        ReactDOM.unmountComponentAtNode(createAdvertModalElement);
    }

    renderContatDetails() {
        let _url = `${BASE.url}`;
        let _classhide;
        let _classshow;
        let _classhidew;
        let whatsapp = this.state.ads_whatsapp_number;
        if (whatsapp == null || whatsapp == '') {
            _classhidew = 'hide';
        }

        return (
            <div className='App'>
                <div className="content">
                    <div id="infoModal" className="modal_v4">
                        {this.Recaptcha
                            ?
                            <Recaptcha
                                sitekey="6LchtAkUAAAAALkBdUSagiPfSMLeJzfVJ9Ds8qQk"
                                verifyCallback={res => this.verifyCallback(res)}
                                onloadCallback={() => this.loaded()}
                            />
                            : <div>
                                <div className="modalHeader">
                                    <div className="img">
                                        <img src={this.state._userimge} className='imagemodal' width="70" height="70" />
                                    </div>
                                </div>
                                <div className="modalBody">
                                    <h2 className="user-name">{this.state.name_of_announcer}</h2>
                                    <div className="notes">
                                        {modalV4.contact_1}
                                    </div>
                                    <div>
                                        <div className="form-group">
                                            <a className="btn-phone" href={"tel:" + this.state.ads_contact_number}>
                                                <img src={`${modalV4.url}/v4/image/Call-modal.svg`} className='imagemodal' />
                                                <span>{this.state.ads_contact_number}</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div>
                                        <div className={_classhidew}>
                                            <div className="form-group">
                                                <a className="btn-whats" href={"whatsapp://send?text=" + modalV4.whats_text + ' ' + this.state._ads_title + ' ' + modalV4.whats_message + ', ' + _url + "adverts/" + this.state.ads_id + "&phone=" + this.state.ads_whatsapp_number}>
                                                    <img src={`${modalV4.url}/v4/image/whatsapp-modal.svg`} className='imagemodal' />
                                                    <span>{this.state.ads_whatsapp_number}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="modalFooter">
                            <a className="close" onClick={this.onToggle}>{modalV4.close}</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderContactEmailForm() {
        return (
            <div className='App'>
                <div className="content">
                    <div id="infoModal" className="modal_v4">
                        {this.Recaptcha
                            ?
                            <Recaptcha
                                sitekey="6LchtAkUAAAAALkBdUSagiPfSMLeJzfVJ9Ds8qQk"
                                verifyCallback={res => this.verifyCallback(res)}
                                onloadCallback={() => this.loaded()}
                            />
                            : <div>
                                <div className="modalHeader">
                                    <div className="img">
                                        <img src={this.state._userimge} className='imagemodal' width="70" height="70" />
                                    </div>
                                </div>
                                {this.state.ads_contact_email ?
                                    <div className="modalBody">
                                        <h2 className="user-name">{this.state.name_of_announcer}</h2>
                                        <div className="notes">
                                            {modalV4.contact_3}
                                        </div>
                                        <div className="form-group">
                                            <a className="btn-phone" href={"mailto:" + this.state.ads_contact_email}>
                                                <span>{this.state.ads_contact_email}</span>
                                            </a>
                                        </div>
                                    </div>
                                    : null
                                }
                            </div>
                        }
                        <div className="modalFooter">
                            <a className="close" onClick={this.onToggle}>{modalV4.close}</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { apply_method } = this.props;

        if (apply_method == 2) {
            return this.renderContactEmailForm();
        } else {
            return this.renderContatDetails();
        }
    }

    verifyCallback(response) {
        try {
            this.fetchAdvertDetails(this.props.advert_id, this.props._userimge, this.props.ads_title, response);
        } catch (e) {
        }
    }
    loaded() {
    }
}